import { NeoModel, Utils, Validation, ValueObject } from '@singularsystems/neo-core';

@NeoModel
export default class AllocationManagerLinkedManagerLookupCriteria extends ValueObject {

    public allocationManagerLinkedManagerId: number = 0;

    public allocationManagerId: number = 0;

    public participantId: string = Utils.emptyGuid();

    public participantName: string = "";

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Allocation Manager Linked Manager Lookup Criteria";
    }
}